<div class="player-stats">
    <app-nav-button
        icon="xmark-circle"
        (clickEvent)="onCloseClick()"
        [size]="drawerConfig.closeButtonSize"
        [ngClass]="drawerConfig.closeButtonPosition"
    ></app-nav-button>
    
    <div class="profile-drawer">
        <div class="profile-header">
            <div class="typography-heading-medium-bold-primary">
                {{ nickName }}
            </div>
            <div class="icon-top-percentage">
                <app-icon [icon]="iconForGlobalRank" [colorCss]="colorForGlobalRank" sizeCss="--icon-medium"
                    *ngIf="unlockedGlobalRank" />
                <div class="typography-text-large-regular-secondary">{{ subtitle }}</div>
            </div>
            <div class="pills">
                <app-pill *ngFor="let pill of pills" [label]="pill.label" />
            </div>
        </div>
        <div class="game-stats-list">
            <div class="stats-cell" *ngIf="statsList.length > 0">
                <div *ngFor="let stat of statsList" class="game-stats">
                    <app-icon [icon]="stat.icon" [colorCss]="stat.colorCss" sizeCss="--icon-medium"></app-icon>
                    <div class="typography-text-medium-semibold-primary stat-score-content">
                        {{ stat.label }}
                    </div>
                    <div class="score-container">
                        <div class="amount">
                            <span class="typography-text-medium-semi-bold-secondary stat-score">{{ stat.score }}</span>
                            <app-currency-icon *ngIf="stat.currencyIcon" [icon]="stat.currencyIcon" sizeCss="--icon-medium"></app-currency-icon>
                        </div>
                        <div class="typography-text-small-semibold-secondary top-percentage">
                            {{ stat.percentage }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>